import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { useLanguage } from "@/context/LanguageContext";
import { Panel } from "@/components/ui/Panel";
import {
  BellAlertIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";

export function WatchDogOverviewIntroPanel() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      watchdog: "Hlídací pes",
      quickSelection: "Rychlý výběr",
      quickSelectionText:
        "Jedním kliknutím přepnete mezi sledovanými lokalitami a typy nabídek.",
      alertOverview: "Přehled upozornění",
      alertOverviewText:
        "Na jednom místě vidíte stav psa, režim sledování i e-mailové notifikace.",
    },
    en: {
      watchdog: "Watchdog",
      quickSelection: "Quick selection",
      quickSelectionText:
        "Switch between tracked locations and offer types with one click.",
      alertOverview: "Alert overview",
      alertOverviewText:
        "See watchdog status, tracking mode, and email notifications in one place.",
    },
  }[language];

  return (
    <Panel>
      <div className="space-y-2">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.watchdog}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={MagnifyingGlassIcon}
          title={copy.quickSelection}
          text={copy.quickSelectionText}
        />
        <PortfolioPageInsightItem
          icon={BellAlertIcon}
          title={copy.alertOverview}
          text={copy.alertOverviewText}
        />
      </div>
    </Panel>
  );
}
